import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import EntityTimestamp from '../../entities/entityTimestamp';

/*
 * Delete/nullify anywhere this entityTimestamp is used in other entities
 *
 * @param {EntityTimestamp} entityTimestamp
 */
export function deleteEntityTimestamp(entityTimestamp: EntityTimestamp, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = entityTimestamp.id;
    }

    /* Remove the actual entityTimestamp */
    entityTimestamp.status = 'D';
    entityTimestamp.addedOn = newHRTimestamp();
    entityTimestamp.addedBy = getCurrentUserId();
    entityTimestamp.importSource = targetImportSource;
    entityTimestamp.importId = mergeId;
    store.dispatch(Actions.EntityTimestampActions.removeEntityTimestampQueue(entityTimestamp));
    
}